import {
  ARTICLERICHTEXTGQLSCHEMA,
  TOP10ARTICLEGQLSCHEMA,
  TOP10ARTICLEMAININFOGQLSCHEMA,
} from "./Top10Article";

export const CATEGORYSORTITEMGQLSCHEMA = `
id
Type
RichText{
    ${ARTICLERICHTEXTGQLSCHEMA}
}
`;

export const MAINWEBSITECATEGORYGQLSCHEMA = `
id
MainInfo{
    ${TOP10ARTICLEMAININFOGQLSCHEMA}
}
Top10Articles{
    ${TOP10ARTICLEGQLSCHEMA}
}
SortedItems{
    ${CATEGORYSORTITEMGQLSCHEMA}
}
`;

export const MAINWEBSITEGQLSCHEMA = `
id
MainInfo{
    ${TOP10ARTICLEMAININFOGQLSCHEMA}
}
HomePage{
    ${TOP10ARTICLEGQLSCHEMA}
}
Categories{
    ${MAINWEBSITECATEGORYGQLSCHEMA}
}
`;
